/**
 * Firebase Authentication module.
 * Handles authentication-related functionality.
 *
 * @module firebase/auth
 */

import { app } from "./config";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";

/**
 * Firebase Auth instance
 * @type {import('firebase/auth').Auth}
 */
export const auth = getAuth(app);

/**
 * Sets persistent authentication to improve user experience
 * by maintaining the user's authentication state across sessions.
 *
 * @async
 * @returns {Promise<boolean>} True if persistence was set successfully, false otherwise
 */
export const setPersistentAuth = async () => {
  try {
    await setPersistence(auth, browserLocalPersistence);
    return true;
  } catch (error) {
    console.error("Failed to set auth persistence:", error);
    return false;
  }
};
